<template>
  <khrc-navbar/>
  <research-officers-component/>
</template>

<script>
import ResearchOfficersComponent from '@/components/ResearchOfficersComponent'
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
components:{
  KhrcNavbar,
    ResearchOfficersComponent
}
}
</script>

<style>

</style>